// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { BreakpointValue } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionThemeValue,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { StyledTheme } from "@toolkit/Framework/Types/StyledTheme";
import { useMemo } from "react";
import { useTheme } from "styled-components";

export type SpacingPresetValue = BreakpointValue[];
export type SpacingPresetOption = DataOption<SpacingPresetValue | string>;
export interface SpacingPresetOptionMapper {
    none: SpacingPresetOption;
    standard: SpacingPresetOption;
    narrow: SpacingPresetOption;
    content: SpacingPresetOption;
    custom: SpacingPresetOption;
}
export type SpacingPresetOptions = DataOptions<SpacingPresetOption> & SpacingPresetOptionMapper;
export type SpacingPreset = LiteralUnion<keyof SpacingPresetOptionMapper>;

export const spacingPresetOptions: SpacingPresetOptions = {
    none: { id: "none", displayName: "None", value: [], isDefault: true },
    standard: { id: "standard", displayName: "Standard", value: "design.layout.spacing.content" },
    narrow: { id: "narrow", displayName: "Narrow", value: "design.layout.spacing.narrowContent" },
    content: { id: "content", displayName: "Content", value: "design.typography.spacing.base" },
    custom: { id: "custom", displayName: "Custom", value: "" },
};

export type SpacingPresetFieldValue = SpacingPreset | undefined;
export interface SpacingPresetFieldOptions {
    isChildDefinition?: boolean;
    showCustom?: boolean;
}

export const getSpacingPresetFieldData = (
    value: SpacingPresetFieldValue,
    theme: StyledTheme,
    options?: SpacingPresetFieldOptions,
) => {
    if (!value) {
        return undefined;
    }

    const data = getDataOptionThemeValue<SpacingPresetValue>(spacingPresetOptions, value, theme);

    return data ? (Array.isArray(data) ? data : [data]) : undefined;
};

export const getSpacingPresetFieldDefinition = (name: string, options?: SpacingPresetFieldOptions) => {
    const { isChildDefinition, showCustom } = options || {};

    const dataOptions = { ...spacingPresetOptions };
    dataOptions.custom.hidden = !showCustom;

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(dataOptions),
        name,
        displayName: "Spacing Preset",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getSpacingPresetField = (name: string, options?: SpacingPresetFieldOptions) => {
    const parse = (value: SpacingPresetFieldValue, theme: StyledTheme) => {
        return getSpacingPresetFieldData(value, theme, options);
    };

    return {
        definition: getSpacingPresetFieldDefinition(name, options),
        parse,
        useParse: (value: SpacingPresetFieldValue) => {
            const theme = useTheme();

            return useMemo(() => parse(value, theme), [value, theme]);
        },
    };
};

export default getSpacingPresetField;
